var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaskIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 11,
    viewBox: "0 0 16 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.61342 5.97513C1.52262 5.83137 1.47723 5.75949 1.45182 5.64862C1.43273 5.56534 1.43273 5.43401 1.45182 5.35073C1.47723 5.23986 1.52262 5.16798 1.61341 5.02422C2.36369 3.83624 4.59693 0.833008 8.00027 0.833008C11.4036 0.833008 13.6369 3.83623 14.3871 5.02422C14.4779 5.16798 14.5233 5.23986 14.5487 5.35073C14.5678 5.43401 14.5678 5.56534 14.5487 5.64862C14.5233 5.75949 14.4779 5.83137 14.3871 5.97513C13.6369 7.16311 11.4036 10.1663 8.00027 10.1663C4.59693 10.1663 2.36369 7.16311 1.61342 5.97513Z",
    stroke: "#475467",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00027 7.49967C9.10484 7.49967 10.0003 6.60424 10.0003 5.49967C10.0003 4.39511 9.10484 3.49967 8.00027 3.49967C6.8957 3.49967 6.00027 4.39511 6.00027 5.49967C6.00027 6.60424 6.8957 7.49967 8.00027 7.49967Z",
    stroke: "#475467",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaskIcon);
export default __webpack_public_path__ + "static/media/maskIcon.f3dee7d56037f6ae5d05dbdb4d5b70d5.svg";
export { ForwardRef as ReactComponent };